export default __webpack_public_path__ + "static/media/therapist.51a1abfd.svg";